
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.994 5.99A5.997 5.997 0 110 5.99a5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M9.72 8.63a.91.91 0 11-1.288 1.288A.91.91 0 019.72 8.63zM4.553 5.24l.281-.281c.003-.003.003-.007.005-.01l.602.602.556-.557L3.67 2.667a1.636 1.636 0 00-.428-1.555A1.635 1.635 0 001.65.695l.907.906A.811.811 0 111.409 2.75l-.906-.906c-.15.55-.016 1.16.416 1.592.422.422 1.015.56 1.555.427l2.037 2.036a.418.418 0 00.036-.162z"}}),_c('path',{attrs:{"d":"M10.338 8.01a1.776 1.776 0 00-1.767-.44L6.426 5.425l-.557.556.602.602c-.003.002-.007.002-.01.005l-.28.28-.498.005a.417.417 0 00-.162.037l1.061 1.062.794.793a1.775 1.775 0 00.44 1.767 1.783 1.783 0 002.522-2.522z"}}),_c('path',{attrs:{"d":"M5.869 5.98l3.572-3.572.363-.175a.996.996 0 00.457-.449l.415-.824-.058-.058-.1-.1-.058-.058-.824.415a.997.997 0 00-.45.458l-.174.362-3.016 3.016-.556.556zM6.18 6.87l.28-.28c.004-.003.008-.002.01-.005l-.601-.602-.429-.429-.602-.602c-.002.003-.001.007-.004.01l-.281.281-.006.497a.42.42 0 01-.036.162.42.42 0 01-.346.253l-.484.046a.267.267 0 00-.163.077L.903 8.894a.266.266 0 000 .377l1.25 1.25a.266.266 0 00.377 0l2.615-2.617a.267.267 0 00.077-.163l.046-.484a.42.42 0 01.252-.345.423.423 0 01.163-.036zM3.939 6.97L1.712 9.197M4.503 7.53L2.276 9.757"}})])])
          )
        }
      }
    